export var AlignmentType;
(function (AlignmentType) {
    AlignmentType["Left"] = "left";
    AlignmentType["Center"] = "center";
    AlignmentType["Right"] = "right";
})(AlignmentType || (AlignmentType = {}));
export var Breakpoints;
(function (Breakpoints) {
    Breakpoints["Mobile"] = "mobile";
    Breakpoints["Tablet"] = "tablet";
    Breakpoints["Desktop"] = "desktop";
})(Breakpoints || (Breakpoints = {}));
//# sourceMappingURL=oh-intro-text.types.js.map
